import {Injectable} from '@angular/core';

import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private matDialog: MatDialog) {}

  open(component: any, model?: any): MatDialogRef<any, any> {
    const dialogRef = this.matDialog.open(component, {
      data: model,
      disableClose: true,
      panelClass: 'dialog',
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      autoFocus: false,
    } as MatDialogConfig);

    return dialogRef;
  }

}
